import { render, staticRenderFns } from "./CompMultipleSteps.vue?vue&type=template&id=20a23fe0&"
import script from "./CompMultipleSteps.vue?vue&type=script&lang=ts&"
export * from "./CompMultipleSteps.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports